module.exports = __webpack_public_path__ + "static/media/private.08e543c1.svg";